type ActionTypes = {
  GET_AUTODESK_ACCESS_TOKEN_START: string;
  GET_AUTODESK_ACCESS_TOKEN_SUCCESS: string;
  GET_AUTODESK_ACCESS_TOKEN_FAILURE: string;
  GET_AUTODESK_FILE_START: string;
  GET_AUTODESK_FILE_SUCCESS: string;
  GET_AUTODESK_FILE_FAILURE: string;
  ADD_SAME_AUTODESK_FILE_LOADED: string;
  RESET_AUTODESK: string;
};

export const AutodeskActionTypes: ActionTypes = {
  GET_AUTODESK_ACCESS_TOKEN_START: '@@GET_AUTODESK_ACCESS_TOKEN_START',
  GET_AUTODESK_ACCESS_TOKEN_SUCCESS: '@@GET_AUTODESK_ACCESS_TOKEN_SUCCESS',
  GET_AUTODESK_ACCESS_TOKEN_FAILURE: '@@GET_AUTODESK_ACCESS_TOKEN_FAILURE',
  GET_AUTODESK_FILE_START: '@@GET_AUTODESK_FILE_START',
  GET_AUTODESK_FILE_SUCCESS: '@@GET_AUTODESK_FILE_SUCCESS',
  GET_AUTODESK_FILE_FAILURE: '@@GET_AUTODESK_FILE_FAILURE',
  ADD_SAME_AUTODESK_FILE_LOADED: '@@ADD_SAME_AUTODESK_FILE_LOADED',
  RESET_AUTODESK: '@@RESET_AUTODESK'
};

export interface AutodeskState {
  loadingToken?: boolean;
  loadingFile?: boolean;
  loadingTokenError?: string;
  loadingFileError?: string;
  file?: {
    urn: string;
    name: string;
    id: string;
  };
  sameFileLoaded?: number;
  authInfo?: {
    accessToken?: string;
    expiresIn?: number;
  };
}
